//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'SGAAS',
  data () {
    return {
      defaultJson: {
        '足底纹理': '足底纹理',
        '乳头形成': '乳头形成',
        '指甲': '指甲',
        '皮肤组织': '皮肤组织'
      },
      form: {
        zdwl: '',
        rtxc: '',
        zj: '',
        pfzz: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '1', name: '前半部红痕，褶痕不明显'},
        {value: '2', name: '红痕＞前半部，褶痕＜前1/3'},
        {value: '3', name: '褶痕＞前2/3'},
        {value: '4', name: '明显的深褶痕＞前2/3'}
      ],
      dataList2: [
        {value: '0', name: '难认，无乳晕'},
        {value: '1', name: '明显可见，乳晕淡、平，直径＜0.75cm'},
        {value: '2', name: '乳晕呈点状，边缘不突起，直径＜0.75cm'},
        {value: '3', name: '乳晕呈点状，边缘不突起，直径＞0.75cm'}
      ],
      dataList3: [
        {value: '1', name: '未达指尖'},
        {value: '2', name: '已达指尖'},
        {value: '3', name: '超过指尖'}
      ],
      dataList4: [
        {value: '0', name: '很薄，胶冻状'},
        {value: '1', name: '薄而光滑'},
        {value: '2', name: '光滑，中等厚度，皮疹或表皮翘起'},
        {value: '3', name: '稍厚，表皮皱裂翘起，以手足最为明显'},
        {value: '4', name: '厚，羊皮纸样，皱裂深浅不一'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // weight + airways + systolicBP + cns + cutaneousWound + fracture
        let result = form.zdwl + form.rtxc + form.zj + form.pfzz + 27
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/SGAAS.vue